import { EventEmitter } from "@angular/core";
import { environment } from "@env/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TemplateService {
    constructor(http) {
        this.http = http;
        this.template_types = [
            { id: "0", name: "PROJETO" },
            { id: "1", name: "ARTIGO" },
            { id: "2", name: "TCC" },
            { id: "3", name: "MONOGRAFIA" },
            { id: "4", name: "DISSERTAÇÃO" },
            { id: "5", name: "TESE" },
            { id: "6", name: "RELATÓRIO" },
            { id: "7", name: "MODELO DE NEGÓCIO" },
            { id: "8", name: "REVISÃO SISTEMÁTICA" },
            { id: "9", name: "REVISÃO INTEGRATIVA" },
            { id: "10", name: "TRABALHO - SALA DE AULA" },
        ];
        this.preTextualsMenuItems = [];
        this.posTextualsMenuItems = [];
    }
    get templateTypes() {
        return this.template_types;
    }
    addPreTextualsMenuItems(preTextualsMenuItems) {
        this.preTextualsMenuItems = preTextualsMenuItems;
        TemplateService.preTextualsMenuItemsAdded.emit(this.preTextualsMenuItems);
    }
    addPosTextualsMenuItems(posTextualsMenuItems) {
        this.posTextualsMenuItems = posTextualsMenuItems;
        TemplateService.posTextualsMenuItemsAdded.emit(this.posTextualsMenuItems);
    }
    addTextualsMenuItems(textualsMenuItems) {
        TemplateService.textualsMenuItemsAdded.emit(this.posTextualsMenuItems);
    }
    index(projectId) {
        return this.http.get(`${environment.base_url}/templates/${projectId}/list_templates`);
    }
    getTemplate(templateId) {
        return this.http.get(`${environment.base_url}/templates/${templateId}`);
    }
    listTemplatesByAuthor() {
        return this.http.get(`${environment.base_url}/templates/list_templates_by_author`);
    }
    getBase64Image(url) {
        return this.http.post(`${environment.base_url}/templates/url_image`, url);
    }
    store(form) {
        return this.http.post(`${environment.base_url}/templates`, form);
    }
    editNameTemplate(form) {
        return this.http.post(`${environment.base_url}/templates/edit_name_template`, form);
    }
    delete(templateId) {
        return this.http.delete(`${environment.base_url}/templates/${templateId}`);
    }
    applyTemplate(form, projectId) {
        return this.http.put(`${environment.base_url}/templates/${projectId}/apply`, form);
    }
    getTextStructures(templateId, projectId) {
        return this.http.get(`${environment.base_url}/templates/${templateId}/${projectId}/get_text_structures`);
    }
    storeGeneralStructure(formData) {
        return this.http.post(`${environment.base_url}/templates/text_structures/generals`, formData);
    }
    storeFontStructure(formData) {
        return this.http.post(`${environment.base_url}/templates/text_structures/fonts`, formData);
    }
    storeCoverStructure(payload) {
        return this.http.post(`${environment.base_url}/templates/text_structures/covers`, payload, {
            reportProgress: true,
            observe: "response",
        });
    }
    storeIllustrationStructure(formData) {
        return this.http.post(`${environment.base_url}/templates/text_structures/illustrations`, formData);
    }
    storePreTextualStructure(formData) {
        return this.http.post(`${environment.base_url}/templates/text_structures/pretextuals`, formData);
    }
    storePosTextualStructure(formData) {
        return this.http.post(`${environment.base_url}/templates/text_structures/postextuals`, formData);
    }
    storeTextualStructure(formData) {
        return this.http.post(`${environment.base_url}/templates/text_structures/textuals`, formData);
    }
    updateGeneralStructure(formData, id) {
        return this.http.put(`${environment.base_url}/templates/text_structures/generals/${id}`, formData);
    }
    updateFontStructure(formData, id) {
        return this.http.put(`${environment.base_url}/templates/text_structures/fonts/${id}`, formData);
    }
    updateIllustrationStructure(formData, id) {
        return this.http.put(`${environment.base_url}/templates/text_structures/illustrations/${id}`, formData);
    }
    updateCoverStructure(formData) {
        return this.http.post(`${environment.base_url}/templates/text_structures/covers/update`, formData, {
            reportProgress: true,
            observe: "events",
        });
    }
    // storeCoverStructure(payload: FormData) {
    //   return this.http.post<TextStructureCover>(`${environment.base_url}/templates/text_structures/covers`, payload, {
    //     reportProgress: true,
    //     observe: 'response'
    //   });
    // }
    updatePreTextualStructure(formData, id) {
        return this.http.put(`${environment.base_url}/templates/text_structures/pretextuals/${id}`, formData);
    }
    updatePosTextualStructure(formData, id) {
        return this.http.put(`${environment.base_url}/templates/text_structures/postextuals/${id}`, formData);
    }
    updateTextualStructure(formData, id) {
        return this.http.put(`${environment.base_url}/templates/text_structures/textuals/${id}`, formData);
    }
    fetchTextStructure() {
        return this.http.get(`${environment.base_url}/templates/text_structures/fetch_text_structure`);
    }
    getMainAuthorAffiliation(projectId) {
        return this.http.get(`${environment.base_url}/templates/${projectId}/get_main_author_affiliation`);
    }
}
TemplateService.preTextualsMenuItemsAdded = new EventEmitter();
TemplateService.posTextualsMenuItemsAdded = new EventEmitter();
TemplateService.textualsMenuItemsAdded = new EventEmitter();
TemplateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TemplateService_Factory() { return new TemplateService(i0.ɵɵinject(i1.HttpClient)); }, token: TemplateService, providedIn: "root" });
